import HR from './index'
import PermSchema from '@/modules/acl/permission_schema'
import StaffInformation from './staff-information'
import StaffInformationDetail from './staff-information/detail'
import StaffStatistics from './staff-statistics'

export default [
  {
    path: '/human-resources',
    component: HR,
    meta: PermSchema.HR
  },
  {
    name: '/human-resources/staff-information',
    path: '/human-resources/staff-information',
    component: StaffInformation,
    meta: PermSchema.HR
  },
  {
    name: '/human-resources/staff-information/detail',
    path: '/human-resources/staff-information/detail',
    component: StaffInformationDetail,
    meta: PermSchema.HR,
    props: (route) => ({
      id: route.query.id ? route.query.id : route.params.id,
      mode: route.query.mode || route.params.mode || ((route.query.id ? route.query.id : route.params.id) ? 'EDIT' : 'CREATE'),
      department: route.query.department ? route.query.department : route.params.department,
      data: route.params.data
    })
  },
  {
    name: '/human-resources/staff-statistics',
    path: '/human-resources/staff-statistics',
    component: StaffStatistics,
    meta: PermSchema.HR
  },
]
